/**
 * Footer Accordion functionality
 * REFACTORED TO USE MODERN CLASS SYNTAX
 */
(function() {
  'use strict';

  class FooterAccordion {
    constructor(container) {
      this.container = container;
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.init();
    }

    init() {
      this.bindEvents();
      this.initializeState();
      this.handleBreakpointChange(this.mediaQuery);
    }

    initializeState() {
      const toggles = this.container.querySelectorAll('[data-accordion-toggle]');
      toggles.forEach(button => {
        const group = button.closest('.footer-accordion__group');
        const submenuId = button.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);

        if (group && submenu) {
          const startOpen = group.getAttribute('data-start-open') === 'true';
          if (startOpen) {
            button.setAttribute('aria-expanded', 'true');
            group.classList.add('is-expanded');
            this.setOpenHeight(submenu);
          } else {
            button.setAttribute('aria-expanded', 'false');
            group.classList.remove('is-expanded');
            submenu.style.height = '0px';
            submenu.style.overflow = 'hidden';
          }
        }
      });
    }

    bindEvents() {
      // Use event delegation for click events
      this.container.addEventListener('click', (e) => {
        let control = e.target.closest('[data-accordion-toggle]');
        if (control) {
          const clickedLink = e.target.closest('a');
          if (clickedLink && !clickedLink.hasAttribute('data-prevent-nav')) {
            return; // Allow navigation for normal links
          }
          e.preventDefault();
          this.toggleAccordion(control);
        }
      });

      // Use event delegation for keyboard events
      this.container.addEventListener('keydown', (e) => {
        const toggle = e.target.closest('[data-accordion-toggle]');
        if (toggle && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          this.toggleAccordion(toggle);
        }
      });

      // Media query listener
      this.mediaQuery.addEventListener('change', (mq) => this.handleBreakpointChange(mq));
    }

    toggleAccordion(button) {
      if (getComputedStyle(button).display === 'none') {
        return;
      }

      const group = button.closest('.footer-accordion__group');
      if (!group) return;

      const submenuId = button.getAttribute('aria-controls');
      const submenu = group.querySelector(`#${submenuId}`);
      if (!submenu) return;
      
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const newExpandedState = !isExpanded;

      const allControls = group.querySelectorAll('[data-accordion-toggle]');
      allControls.forEach(control => control.setAttribute('aria-expanded', newExpandedState));

      if (newExpandedState) {
        group.classList.add('is-expanded');
        this.setOpenHeight(submenu);
      } else {
        group.classList.remove('is-expanded');
        this.collapseSubmenu(submenu);
      }
    }

    setOpenHeight(submenu) {
      submenu.style.display = 'block';
      submenu.style.overflow = 'hidden';
      submenu.style.height = 'auto';
      const height = submenu.scrollHeight;
      submenu.style.height = '0px';

      requestAnimationFrame(() => {
        submenu.style.height = `${height}px`;
      });

      const onTransitionEnd = () => {
        if (submenu.style.height === `${height}px`) {
          submenu.style.height = 'auto';
        }
        submenu.removeEventListener('transitionend', onTransitionEnd);
      };
      submenu.addEventListener('transitionend', onTransitionEnd);
    }
    
    collapseSubmenu(submenu) {
      const height = submenu.scrollHeight;
      submenu.style.height = `${height}px`;

      requestAnimationFrame(() => {
        submenu.style.height = '0px';
      });
    }

    handleBreakpointChange() {
      const groups = this.container.querySelectorAll('.footer-accordion__group');
      groups.forEach(group => {
        const anyControl = group.querySelector('[data-accordion-toggle]');
        const submenu = group.querySelector('.footer-accordion__submenu');
        if (!anyControl || !submenu) return;

        const isExpanded = anyControl.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          this.setOpenHeight(submenu);
        } else {
          submenu.style.height = '0px';
          submenu.style.overflow = 'hidden';
        }
      });
    }
  }

  function init() {
    const accordionContainers = document.querySelectorAll('[data-footer-accordion]');
    accordionContainers.forEach(container => {
      new FooterAccordion(container);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ensure no-js class is removed
  document.documentElement.classList.remove('no-js');
})();